import React from "react";

const CustomAlert = ({ 
  isOpen, 
  onClose, 
  message, 
  type = "info", 
  title = null,
  showCloseButton = true,
  autoClose = false,
  autoCloseDelay = 5000,
  onConfirm = null
}) => {
  React.useEffect(() => {
    if (autoClose && isOpen) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);
      return () => clearTimeout(timer);
    }
  }, [isOpen, autoClose, autoCloseDelay, onClose]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case "success":
        return "✅";
      case "error":
        return "❌";
      case "warning":
        return "⚠️";
      case "info":
      default:
        return "ℹ️";
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case "success":
        return "#d4edda";
      case "error":
        return "#f8d7da";
      case "warning":
        return "#fff3cd";
      case "info":
      default:
        return "#d1ecf1";
    }
  };

  const getBorderColor = () => {
    switch (type) {
      case "success":
        return "#c3e6cb";
      case "error":
        return "#f5c6cb";
      case "warning":
        return "#ffeaa7";
      case "info":
      default:
        return "#bee5eb";
    }
  };

  const getTextColor = () => {
    switch (type) {
      case "success":
        return "#155724";
      case "error":
        return "#721c24";
      case "warning":
        return "#856404";
      case "info":
      default:
        return "#0c5460";
    }
  };

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "20px"
    }}>
      <div style={{
        background: "white",
        borderRadius: "12px",
        padding: "24px",
        maxWidth: "500px",
        width: "100%",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
        border: `3px solid ${getBorderColor()}`,
        position: "relative"
      }}>
        {/* Header */}
        <div style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px"
        }}>
          <span style={{
            fontSize: "24px",
            marginRight: "12px"
          }}>
            {getIcon()}
          </span>
          <div>
            {title && (
              <h3 style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: "600",
                color: getTextColor()
              }}>
                {title}
              </h3>
            )}
            <div style={{
              fontSize: "16px",
              color: getTextColor(),
              lineHeight: "1.4",
              wordBreak: "break-word",
              overflowWrap: "break-word",
              hyphens: "auto"
            }}>
              {message}
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          gap: "12px"
        }}>
          {onConfirm ? (
            <>
              <button
                onClick={onClose}
                style={{
                  background: "#6c757d",
                  color: "white",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.8";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                }}
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                style={{
                  background: type === "error" ? "#dc3545" : type === "warning" ? "#ffc107" : "#28a745",
                  color: type === "warning" ? "#212529" : "white",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "6px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s ease"
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.8";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                }}
              >
                Confirm
              </button>
            </>
          ) : (
            <button
              onClick={onClose}
              style={{
                background: getBorderColor(),
                color: getTextColor(),
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = "0.8";
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = "1";
              }}
            >
              {type === "error" ? "Close" : "OK"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAlert; 